/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint ignore:start */
import React, { useCallback, useContext, useEffect, useState } from "react";
import { IoIosCheckmarkCircle } from "react-icons/io";
import CloseIcon from "../Icon/times.svg";
import CoinIcon from "../images/icons/buycoin-package.png";
import { MyContext } from "../Context/MyProvider";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { showTost } from "../showTost";
import LodingLottie from "../Lodinglottie";

const GiftModal = ({ isVisible, onClose, receiverId, onGiftSent }) => {
  const { t } = useTranslation();
  const { basUrl, imageBaseURL } = useContext(MyContext);
  const navigate = useNavigate();

  const [giftList, setGiftList] = useState([]);
  const [yourCoin, setYourCoin] = useState(0);
  const [giftid, setGiftId] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);
  const [giftImg, setGiftImg] = useState([]);
  const [loading, setLoading] = useState(true);

  const getUserId = () => {
    try {
      return JSON.parse(localStorage.getItem("Register_User") || "{}").id;
    } catch {
      return null;
    }
  };

  const CoinHandler = useCallback(() => {
    const uid = getUserId();
    if (uid) {
      axios
        .post(`${basUrl}coin_report`, { uid })
        .then((res) => setYourCoin(res.data.coin));
    }
  }, [basUrl]);

  const GetGiftListHandle = useCallback(() => {
    setLoading(true);
    axios
      .post(`${basUrl}gift_list`)
      .then((res) => {
        setGiftList(res.data.giftlist || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching gift list:", err);
        setLoading(false);
      });
  }, [basUrl]);

  useEffect(() => {
    if (isVisible) {
      GetGiftListHandle();
      CoinHandler();
      setGiftId([]);
      setTotalPrice(0);
      setGiftImg([]);
    }
  }, [CoinHandler, GetGiftListHandle, isVisible]);

  const GiftHandler = (id, price, img) => {
    const GiftCoin = parseInt(price);
    if (giftid.includes(id)) {
      setGiftId(giftid.filter((el) => el !== id));
      setGiftImg(giftImg.filter((el) => el !== img));
      setTotalPrice(totalPrice - GiftCoin);
    } else {
      if (totalPrice + GiftCoin > yourCoin) {
        showTost({ title: t("insufficient coins in wallet") });
        navigate("/buycoin");
      } else {
        setGiftId([...giftid, id]);
        setTotalPrice(totalPrice + GiftCoin);
        setGiftImg([...giftImg, img]);
      }
    }
  };

  const SendHandler = () => {
    if (giftid.length === 0) {
      showTost({ title: t("Please Select Gift") });
      return;
    }

    const uid = getUserId();
    if (uid && receiverId) {
      axios
        .post(`${basUrl}giftbuy`, {
          sender_id: uid,
          coin: totalPrice,
          receiver_id: receiverId,
          gift_img: giftImg.join(";"),
          gift_ids: giftid,
        })
        .then((res) => {
          if (res.data.Result === "true") {
            if (onGiftSent) onGiftSent();
            onClose();
          } else {
            showTost({ title: res.data.ResponseMsg || t("Something Went Wrong!") });
            if (String(res.data.ResponseCode) === "402") {
              navigate("/buycoin");
            }
          }
        })
        .catch((error) => {
          console.error("Error sending gift:", error);
          showTost({ title: t("Something Went Wrong!") });
        });
    }
  };

  if (!isVisible) return null;

  return (
    <div onClick={onClose} className="bottom-sheet z-[999]">
      <div onClick={(e) => e.stopPropagation()} className="bottom-sheet-content">
        <div className="flex items-center justify-between">
          <h1 className="text-[18px] m-0 font-[600]">{t("Send Gifts")}</h1>
          <div className="flex items-center gap-[10px]">
            <img src={CoinIcon} alt="" className="w-[25px]" />
            <span className="text-[18px]">{yourCoin}</span>
            <img
              onClick={onClose}
              src={CloseIcon}
              alt=""
              className="w-[15px] ms-[15px] cursor-pointer"
            />
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-[20px] mx-auto mt-3 max-_430_:gap-[10px] min-h-[100px]">
          {loading ? (
            <LodingLottie ClassCss="w-[50px] h-[50px] my-4" />
          ) : giftList.length > 0 ? (
            giftList.map((el, i) => (
              <button
                key={i}
                onClick={() => GiftHandler(el.id, el.price, el.img)}
                style={{
                  borderColor: giftid.includes(el.id)
                    ? "rgba(152,14,255,255)"
                    : "#D1D5DB",
                }}
                className="w-[20%] max-_430_:w-[calc(25%-10px)] border-[2px] flex justify-center py-[5px] rounded-[10px] relative"
              >
                <div className="relative">
                  <img
                    src={imageBaseURL + el.img}
                    alt=""
                    className="w-[45px] h-[45px] mx-auto max-_380_:w-[40px] max-_380_:h-[40px] max-_330_:w-[30px] max-_330_:h-[30px]"
                  />
                  <div className="flex items-center justify-center gap-[5px] mt-2">
                    <img
                      src={CoinIcon}
                      alt=""
                      className={`w-[15px] ${el.price === "0" && "hidden text-center"}`}
                    />
                    <span className="text-[14px] font-[500]">
                      {el.price === "0" ? t("Free") : el.price}
                    </span>
                  </div>
                  <IoIosCheckmarkCircle
                    style={{
                      display: giftid.includes(el.id) ? "block" : "none",
                    }}
                    className="absolute -top-[15px] -right-[30px] max-_380_:-right-[20px] max-_330_:-right-[10px] w-[25px] h-[25px] text-[rgba(152,14,255,255)] bg-white rounded-full"
                  />
                </div>
              </button>
            ))
          ) : (
            <div className="text-center text-gray-500 py-4 w-full">
              {t("No Gifts Available")}
            </div>
          )}
        </div>
        <button
          onClick={SendHandler}
          className="font-bold text-[18px] rounded-[10px] mt-[20px] text-white py-[10px] w-[100%] bg-[rgba(152,14,255,255)]"
        >
          {t("Send")}
        </button>
      </div>
    </div>
  );
};

export default GiftModal;
/* jshint ignore:end */
